import React from 'react';
import { InboxList } from './InboxList';
import { GenericCard } from '@/components/dashboard';
import { NewEmail } from './NewEmail';
import { useRouter } from 'next/router';

export const InboxLawyerScreen: React.FC = () => {
	const router = useRouter();
	const { clientId } = router.query;
	const [openNewEmail, setOpenNewMessage] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (clientId) {
			setOpenNewMessage(true);
		}
	}, [clientId]);

	return (
		<>
			<GenericCard className="relative md:!h-full md:!min-h-[77vh] 3xl:!min-h-[75vh]">
				<InboxList setOpenNewMessage={setOpenNewMessage} />
			</GenericCard>
			<NewEmail
				openNewEmail={openNewEmail}
				setOpenNewMessage={setOpenNewMessage}
			/>
		</>
	);
};
